import debounce from 'lodash/debounce'
import { useCallback, useMemo, useRef } from 'react'
import { TextHighlighterItemArgsInput } from '../../data/gql-gen/questionnaire/graphql'
import { LoggerErrorType } from '../../data/logger'
import { captureApolloError } from '../../utils/HelperFunctions'
import { useUpdateQuestionnaireEntry } from './useUpdateQuestionnaireEntry'

export const useUpdateTextHighlighter = ({
  questionId
}: {
  questionId: string
}) => {
  const { updateQuestionnaireEntry } = useUpdateQuestionnaireEntry(questionId, {
    onError: (error) => {
      captureApolloError(
        LoggerErrorType.ApolloMutation,
        'updateTextHighlighter',
        error
      )
    }
  })

  const updateTextHighlighter = useCallback(
    (input: TextHighlighterItemArgsInput) => {
      updateQuestionnaireEntry({
        updateTextHighlighter: {
          ...input
        }
      })
    },
    [updateQuestionnaireEntry]
  )

  const debouncedRef = useRef<ReturnType<typeof debounce>>()

  const updateTextHighlighterDebounced = useMemo(() => {
    const debouncedFn = debounce((input: TextHighlighterItemArgsInput) => {
      updateQuestionnaireEntry({
        updateTextHighlighter: {
          ...input
        }
      })
    }, 1000)

    debouncedRef.current = debouncedFn
    return debouncedFn
  }, [updateQuestionnaireEntry])

  const cancelPendingUpdate = useCallback(() => {
    debouncedRef.current?.cancel()
  }, [])

  return {
    updateTextHighlighter,
    updateTextHighlighterDebounced,
    cancelPendingUpdate
  }
}
